import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { RouterProvider } from 'react-router-dom';

import { router } from 'router/router';

library.add(fab, fas);

const App = () => {

    return (
        <React.StrictMode>
            <RouterProvider router={router} fallbackElement={<p>Test...</p>} />
        </React.StrictMode>
    );
}

export default App;